/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SubscriptIcon = /*#__PURE__*/ createSvgIcon(
  'SubscriptIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M13.717 16.5a.97.97 0 01-.713-.287.963.963 0 01-.287-.71v-.996a.98.98 0 01.287-.715.96.96 0 01.713-.292h1v-1h-1.5a.48.48 0 01-.35-.15.48.48 0 010-.7c.1-.1.216-.15.35-.15h1.5a.97.97 0 01.712.287.963.963 0 01.288.71v.996a.98.98 0 01-.288.715.96.96 0 01-.712.292h-1v1h1.5c.133 0 .25.05.35.15a.48.48 0 010 .7.48.48 0 01-.35.15h-1.5zm-8.908-3c-.325 0-.561-.135-.707-.406-.146-.271-.135-.544.031-.82l2.521-3.982-2.29-3.587a.754.754 0 01-.043-.799c.139-.27.367-.406.684-.406.147 0 .281.035.404.104.122.07.217.16.287.271l1.979 3.188 2.062-3.209a.695.695 0 01.28-.261.807.807 0 01.378-.093c.327 0 .563.139.708.417a.765.765 0 01-.032.812L8.758 8.292 11.3 12.27a.763.763 0 01.031.812.727.727 0 01-.689.417.762.762 0 01-.394-.104.809.809 0 01-.281-.271l-2.209-3.5-2.291 3.52a.695.695 0 01-.28.262.807.807 0 01-.378.093z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default SubscriptIcon;
